import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useQuery } from '@tanstack/react-query'
import NotificationAPI from 'api/faber/NotificationAPI'
import AbstractAuditLogDataGrid from 'common/AbstractAuditLogDataGrid'
import { generateColumnHeader } from 'helpers/column-generator/generateColumnHeader'
import { ALL_EMAIL_LOGS } from 'helpers/column-generator/generateColumnHeader'
import OrbitSession from 'hooks/useCookies'
import { EmailHistoryRecord } from 'types/api/faber/notification.type'
import { GetAllFaberUsersDetails } from 'types/api/faber/oneTimePack.type'
import { SubscriptionsTableRows } from 'types/api/faber/subscription.type'

function EmailSentLogsV2({ 
  customerRow,
  expanded,
  isExternal
 }: EmailLogProps) {
  const emailColumns = generateColumnHeader(ALL_EMAIL_LOGS)
  const [emailRows, setEmailRows] = useState<EmailHistoryRecord[]>([])
  const faberToken = OrbitSession.get('faberToken')
  // const userEmail =
  // 'userEmail' in customerRow ? customerRow.userEmail : customerRow?.user_metadata ? customerRow?.user_metadata?.email : customerRow?.email
  // Get user id from customerRow
  const userId = 'userID' in customerRow ? customerRow.userID : customerRow?.user_id
  const queryOptions = React.useMemo(
    () => ({
      userId: userId,
    }),
    [userId]
  )

  const { isLoading: getAllEmailHistoryLoading, refetch: refetchEmail } =
    useQuery(
      ['getAllEmailHistory', [queryOptions]],
      async () => {
        const { userId } = queryOptions
        return (isExternal ? 
        NotificationAPI.getExternalEmailNotificationHistory(
          userId,
          faberToken)
        :
        NotificationAPI.getEmailNotificationHistory(
          userId,
          faberToken))
      },
      {
        onError: () => {
          toast.error('Error getting email notification history')
          setEmailRows([])
        },
        onSuccess: (res) => {
          if (res.data.data === null) {
            setEmailRows([])
          } else {
            setEmailRows(res.data.data.logs)
          }
        },
        enabled: expanded === 'panel5'
      }
    )

  useEffect(() => {
    refetchEmail()
  }, [])

  return (
    <>
      <AbstractAuditLogDataGrid
        tableHeight='350px'
        columns={emailColumns}
        rows={emailRows ?? []}
        loading={getAllEmailHistoryLoading}
        getRowId={(row: EmailHistoryRecord) =>
          row.campaignId + emailRows.indexOf(row)
        }
        pagination
      />
    </>
  )
}

export default EmailSentLogsV2

interface EmailLogProps {
  customerRow: SubscriptionsTableRows | GetAllFaberUsersDetails
  expanded: string | false
  isExternal: boolean
}
